import { useState, useEffect, useRef } from "react";
import Geocode from "react-geocode";
import Autocomplete from "react-google-autocomplete";
import logger from "../../../utils/logger";
import MyGoogleMap from "./MyGoogleMap";

Geocode.setApiKey(import.meta.env.VITE_GOOGLE_MAPS_API_KEY);
Geocode.enableDebug();

const getCity = (addressArray) => {
  for (let i = 0; i < addressArray.length; i++) {
    if (
      addressArray[i].types[0] &&
      "administrative_area_level_2" === addressArray[i].types[0]
    ) {
      return addressArray[i].long_name;
    }
  }
  return "";
};

const getArea = (addressArray) => {
  for (let i = 0; i < addressArray.length; i++) {
    if (addressArray[i].types[0]) {
      for (let j = 0; j < addressArray[i].types.length; j++) {
        if (
          "sublocality_level_1" === addressArray[i].types[j] ||
          "locality" === addressArray[i].types[j]
        ) {
          return addressArray[i].long_name;
        }
      }
    }
  }
  return "";
};

const getState = (addressArray) => {
  for (let i = 0; i < addressArray.length; i++) {
    if (
      addressArray[i].types[0] &&
      "administrative_area_level_1" === addressArray[i].types[0]
    ) {
      return addressArray[i].long_name;
    }
  }
  return "";
};

const Map = ({
  lat: latProp,
  long: longProp,
  address,
  mapUpdate,
  updateAddress,
  onRef,
  coords,
  isGeolocationAvailable,
  isGeolocationEnabled,
  placeId: placeIdProp,
}) => {
  const [lat, setLat] = useState(latProp || 33.7488);
  const [long, setLong] = useState(longProp || -84.3877);
  const [placeId, setPlaceId] = useState("");

  // Always-fresh ref so the parent's stable handle never goes stale
  const updateFormMapDataRef = useRef(null);
  updateFormMapDataRef.current = () => {
    mapUpdate && mapUpdate({ address, lat, long, placeId });
  };

  // componentDidMount: register ref and fetch current location
  useEffect(() => {
    if (onRef) {
      onRef({ updateFormMapData: () => updateFormMapDataRef.current() });
    }
    if (isGeolocationAvailable && isGeolocationEnabled && coords) {
      setLat(coords.latitude);
      setLong(coords.longitude);
    } else {
      logger.log("location denied");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // componentWillReceiveProps equivalent: geocode new coords when they arrive
  useEffect(() => {
    if (coords && placeIdProp === "") {
      Geocode.fromLatLng(coords.latitude, coords.longitude).then(
        (response) => {
          const addr = response.results[0].formatted_address;
          const addressArray = response.results[0].address_components;
          updateAddress && updateAddress(addr);
          setLat(response.results[0].geometry.location.lat);
          setLong(response.results[0].geometry.location.lng);
          setPlaceId(response.results[0].place_id);
        },
        (error) => {
          logger.error(error);
        }
      );
    }
  }, [coords]); // eslint-disable-line react-hooks/exhaustive-deps

  const updateFormMapData = updateFormMapDataRef.current;

  const onMarkerDragEnd = (e) => {
    Geocode.fromLatLng(e.latLng.lat(), e.latLng.lng()).then(
      (response) => {
        const addr = response.results[0].formatted_address;
        const addressArray = response.results[0].address_components;
        updateAddress && updateAddress(addr);
        setLat(e.latLng.lat());
        setLong(e.latLng.lng());
        setPlaceId(response.results[0].place_id);
      },
      (error) => {
        logger.error(error);
      }
    );
  };

  const onPlaceSelected = (e) => {
    if (e.address_components) {
      const addr = e.formatted_address;
      const latValue = e.geometry.location.lat();
      const lngValue = e.geometry.location.lng();
      updateAddress && updateAddress(addr);
      setLat(latValue);
      setLong(lngValue);
      setPlaceId(e.place_id);
    }
  };

  const handleInputChange = (event) => {
    updateAddress && updateAddress(event.target.value);
  };

  return (
    <div
      className="google-map-main-container"
      style={{ margin: "24px 20px" }}
    >
      <MyGoogleMap
        lat={lat}
        lng={long}
        onMarkerDragEnd={onMarkerDragEnd}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `70vh`, width: `140vh` }} />}
        mapElement={<div style={{ height: `100%` }} />}
      />

      <Autocomplete
        style={{ width: "100%", height: "40px", paddingLeft: "16px" }}
        value={address}
        onChange={handleInputChange}
        onPlaceSelected={onPlaceSelected}
        types={["establishment", "geocode"]}
      />
    </div>
  );
};

export default Map;
